import React from 'react';
import { Region } from './Region.js';

/**
 * After wavesurfer.js@^7, Marker can be created with Region w/o end.
 * I.e., a region should have no duration to behave like a marker.
 */ function Marker(props) {
    return /*#__PURE__*/ React.createElement(Region, props);
}

export { Marker as default };
